import buildings from '../../assets/buildings.webp';
import buildings2 from '../../assets/buildings2.webp';
import buildings3 from '../../assets/buildings3.webp';
import tree1 from '../../assets/tree1.webp';
import tree2 from '../../assets/tree2.webp';
import tree3 from '../../assets/tree3.webp';
import tree4 from '../../assets/tree4.webp';
import styled from "styled-components";
import {responsive} from "../../media-quries";
import SearchBar from "./search-bar";

const Container = styled.div`
  position: relative;
  height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${responsive.md`
    margin-top: 40px;
  `}

  ${responsive.sm`
    margin-top: 140px;
  `}
`;
const Buildings1Img = styled.img`
  position: absolute;
  width: 1000px;
  top: 30px;
  left: -100px;
  right: 0;
  margin: auto;

  ${responsive.sm`
    display: none;
  `}
`;
const Buildings2Img = styled.img`
  position: absolute;
  width: 600px;
  right: -250px;

  ${responsive.sm`
    display: none;
  `}
`;
const Buildings3Img = styled.img`
  position: absolute;
  width: 450px;
  top: 100px;
  left: -220px;

  ${responsive.sm`
    display: none;
  `}
`;
const Tree1 = styled.img`
  position: absolute;
  right: -250px;
  top: 550px;

  ${responsive.sm`
    display: none;
  `}
`;
const Tree2 = styled.img`
  position: absolute;
  left: -170px;
  bottom: 180px;
  width: 100px;

  ${responsive.sm`
    display: none;
  `}
`;
const Tree3 = styled.img`
  position: absolute;
  right: 400px;
  top: 400px;
  width: 80px;
  z-index: 9;

  ${responsive.xl`
    right: 260px;
  `}
  
  ${responsive.lg`
    z-index: -1;
  `}

  ${responsive.md`
    z-index: -1;
  `}

  ${responsive.sm`
    z-index: -1;
    display: none;
  `}
`;
const Tree4 = styled.img`
  position: absolute;
  left: 200px;
  top: 530px;
  width: 220px;
  z-index: 9;

  ${responsive.sm`
    display: none;
  `}
`;
const Tree5 = styled.img`
  position: absolute;
  left: 190px;
  top: 440px;
  width: 70px;

  ${responsive.sm`
    display: none;
  `}
`;
const Tree6 = styled.img`
  position: absolute;
  left: 410px;
  top: 440px;
  width: 70px;

  ${responsive.lg`
    z-index: -1;
  `}

  ${responsive.md`
    z-index: -1;
  `}

  ${responsive.sm`
    z-index: -1;
    display: none;
  `}
`;
export const End = styled.div`
  position: absolute;
  left: 50%;
  top: 650px; 
  transform: translateX(-50%);
  width: 100vw;
  height: 100px;
  background: var(--chakra-colors-primary);;
  clip-path: polygon(0 100%, 100% 100%, 100% 50px, 0 0); /* Definicja kształtu */
`;

function HomeHeaderSection({ searching }) {
    return <Container>
        <SearchBar searching={searching} />
        <Buildings1Img src={buildings} />
        <Buildings2Img src={buildings2} />
        <Buildings3Img src={buildings3} />
        <Tree1 src={tree1} />
        <Tree2 src={tree2} />
        <Tree3 src={tree3} />
        <Tree4 src={tree4} />
        <Tree5 src={tree3} />
        <Tree6 src={tree1} />
        <End/>
    </Container>
}

export default HomeHeaderSection;
